import React from 'react';

import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

const Table = (props) => {

    if (props.Category.length == 0)
        return null

    return (
        <div className="row">
            <TableHeader data={props.Category[0].Categoria} />
            <TableBody data={props.Category} />
        </div>
    );
}

export default Table;